import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

/** *
 * Action Block
 */
const Action = ({
  partialUpdateSalesRoute,
  // cancelSalesRoute,
  // putOnHoldSalesRoute,
  labelNextButton,
  // labelCancelButton,
  // labelPutonholdButton,
  isDisabledNextButton,
  isSpinnerNextButton,
}) => {
  return (
    <div className="action">
      {/* <div className="grid-item">
        <button className="button-cancel" type="button" onClick={() => cancelSalesRoute()}>
          {labelCancelButton}
        </button>
      </div>
      <div className="grid-item">
        <button className="button-waiting" type="button" onClick={() => putOnHoldSalesRoute()}>
          {labelPutonholdButton}
        </button>
      </div> */}
      <div className="grid-item">
        <button
          type="button"
          className={cn({ 'button-next': !isDisabledNextButton, 'button-disabled': isDisabledNextButton })}
          disabled={isDisabledNextButton}
          onClick={() => partialUpdateSalesRoute()}
        >
          {isSpinnerNextButton && (
            <FontAwesomeIcon className="spinner-button-style" icon={faCircleNotch} spin size="lg" />
          )}
          <span style={{ marginLeft: '5px' }}>{labelNextButton}</span>
        </button>
      </div>
    </div>
  );
};

Action.propTypes = {
  isSpinnerNextButton: PropTypes.bool,
  isDisabledNextButton: PropTypes.bool.isRequired,
  // function
  partialUpdateSalesRoute: PropTypes.func.isRequired,
  // cancelSalesRoute: PropTypes.func.isRequired,
  // putOnHoldSalesRoute: PropTypes.func.isRequired,
  // label
  labelNextButton: PropTypes.string.isRequired,
  // labelCancelButton: PropTypes.string.isRequired,
  // labelPutonholdButton: PropTypes.string.isRequired,
};

Action.defaultProps = {
  isSpinnerNextButton: false,
};

export default Action;
